import {useEffect, useState} from "react";
import {Button, Col, message, Row, Spin} from "antd";
import SalesPrintComponent from "./SalesPrintComponent";
import Api from "../../../services/Api";

const BuyingSendDataComponent = ({ tempBuyList, paymentType, modalClose }) => {
    const [loading, setLoading] = useState(true);
    const [responseData, setResponseData] = useState(null);


    useEffect(() => {
        sendData()
    }, []);

    const sendData = () => {
        const data = {
            buyer:"system",
            buyType:paymentType,
            buyList:tempBuyList
        }

        Api.post("/api/buys", data).then(res => {
            message.success(res.data.message)
            setResponseData(res.data);
            setLoading(false);

        }).catch(err => {
            message.error("Satış işlemi gerçekleştirilemedi")
            setLoading(false)
        })
    }

    return(
        <Spin spinning={loading}  tip="Sıra numarası alınıyor.." size="large">
            {responseData &&
                <SalesPrintComponent tempBuyList={tempBuyList} paymentType={paymentType} responseData={responseData} />
            }

            <Button onClick={() => modalClose()} className={"w-100 mt-1"} loading={loading} danger={true} type={"primary"}>Kapat</Button>
        </Spin>
    )
}

export default BuyingSendDataComponent;
